export default __webpack_public_path__ + "9d636ded7255cc480fb70b579eef8640.png";